export default __webpack_public_path__ + "static/media/tays-logo.a2c7e459.png";